import { arrType, datatypes, inputTypes } from "data/globalData";

export const discountGroupObjects = {
	brand_channel: {
		name: "BRAND AND CHANNEL",
		key: "brand_channel",
		group_no: 0,
	},
	general_information: {
		name: "GENERAL INFORMATION",
		key: "general_information",
		group_no: 1,
	},
	applicable_date: {
		name: "APPLICABLE DATE",
		key: "applicable_date",
		group_no: 2,
	},
	store_availability: {
		name: "STORE AVAILABILITY",
		key: "store_availability",
		group_no: 3,
	},
	discount_value: {
		name: "DISCOUNT VALUE",
		key: "discount_value",
		group_no: 4,
	},
	product_selection: {
		name: "PRODUCT SELECTION",
		key: "product_selection",
		group_no: 5,
	},
};

export const DISOUNT_MASTER_CHANNEL_OPTIONS = [
	{
		name: "EBO",
		key: "EBO",
	},
	{
		name: "MBO",
		key: "MBO",
	},
	{
		name: "LFS",
		key: "LFS",
	},
	// {
	// 	name: "D2C",
	// 	key: "D2C",
	// },
];

export const Discount_Master_Brands = [
	{
		name: "RARE RABBIT",
		key: "RARE RABBIT",
	},
	{
		name: "RAREISM",
		key: "RAREISM",
	},

	{
		name: "RARE ONES",
		key: "RARE ONES",
	},
	{
		name: "RAREZ",
		key: "RAREZ",
	},
	{
		name: "THOR",
		key: "THOR",
	},
	{
		name: "GUILD",
		key: "GUILD",
	},
	{
		name: "RARE RABBIT FOC",
		key: "RARE RABBIT FOC",
	},
]

const SCHEME_TYPE_OPTIONS = [
	{
		name: "Buy Certain Amount & Get Certain Amount Off",
		key: "Buy_Certain_Amount_Get_Certain_Amount_Off",
	},
	{
		name: "Buy Certain Quantity & Get Certain Quantity Free",
		key: "Buy_Certain_Quantity_Get_Certain_Quantity_Free",
	},
	{
		name: "Buy Certain Amount & Get Certain Quantity Free",
		key: "Buy_Certain_Amount_Get_Certain_Quantity_Free",
	},
	{
		name: "Buy Certain Amount ₹ & Get Certain % Off",
		key: "Buy_Certain_Amount_₹_Get_Certain_%_Off",
	},
	{
		name: "Buy Certain Quantity & Get Certain % Off",
		key: "Buy_Certain_Quantity_Get_Certain_%_Off",
	},
	{
		name: "Buy Certain @ Certain %",
		key: "Buy_Certain_@_Certain_%",
	},
	{
		name: "Flat Discount Amount",
		key: "Flat_Discount_Amount",
	},
	{
		name: "Flat Discount %",
		key: "Flat_Discount_%",
	},
	{
		name: "Buy For Amount & Get product @ Amount",
		key: "Buy_For_Amount_Get_product_@_Amount",
	},
	{
		name: "Buy For Amount & Get Certain Amount Off & product @ Amount",
		key: "Buy_For_Amount_Get_certain_amount_off_&_product_@_Amount",
	},
	{
		name: "NOD",
		key: "NOD",
	},
];

export const BRAND_OPTIONS = [
	{
		name: "RARE RABBIT",
		key: "RARE RABBIT",
		brand_code: "RR",
	},
	{
		name: "RAREISM",
		key: "RAREISM",
		brand_code: "RSM",
	},
	{
		name: "THOR",
		key: "THOR",
		brand_code: "THOR",
	},
	{
		name: "RAREONES",
		key: "RAREONES",
		brand_code: "RO",
	},
	{
		name: "RAREZ",
		key: "RAREZ",
		brand_code: "RZ",
	},
];

export const ZONE_OPTIONS = [
	{
		name: "NORTH",
		key: "NORTH",
	},
	{
		name: "SOUTH",
		key: "SOUTH",
	},
	{
		name: "EAST",
		key: "EAST",
	},
	{
		name: "WEST",
		key: "WEST",
	},
	{
		name: "CENTRAL",
		key: "CENTRAL",
	},
];

export const brand_channel_fields = [
	{
		name: "Brand",
		key: "store_brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.brand_channel.key,
		option_data: {
			type: arrType,
			list: BRAND_OPTIONS,
		},
	},
	{
		name: "Channel",
		key: "channel",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.brand_channel.key,
		option_data: {
			type: arrType,
			list: DISOUNT_MASTER_CHANNEL_OPTIONS,
		},
	},
];

export const master_general_information_fields = [
	{
		name: "Scheme Name",
		key: "scheme_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.general_information.key,
	},
	{
		name: "Scheme Type",
		key: "scheme_type",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.general_information.key,
		option_data: {
			type: arrType,
			list: SCHEME_TYPE_OPTIONS,
		},
	},
	// {
	// 	name: "Brand",
	// 	key: "brand",
	// 	input_type: inputTypes.MULTIPLE_SELECT.key,
	// 	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 1,
	// 	group: discountGroupObjects.general_information.key,
	// 	option_data: {
	// 		type: arrType,
	// 		list: BRAND_OPTIONS,
	// 	},
	// },
	// {
	// 	name: "Scheme Description",
	// 	key: "scheme_description",
	// 	input_type: inputTypes.ENTER.key,
	// 	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.LONGTEXT.key,
	// 	sort_no: 3,
	// 	group: discountGroupObjects.general_information.key,
	// },
];

export const date_availability_fields = [
	{
		name: "Start Date",
		key: "start_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE_TIMESTAMP.key,
		sort_no: 0,
		group: discountGroupObjects.applicable_date.key,
	},
	{
		name: "End Date",
		key: "end_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE_TIMESTAMP.key,
		sort_no: 0,
		group: discountGroupObjects.applicable_date.key,
	},
];

export const buy_value_get_value = [
	{
		name: "Buy",
		key: "buy",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
		group: discountGroupObjects.discount_value.key,
	},
	{
		name: "Get",
		key: "get",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
		group: discountGroupObjects.discount_value.key,
	},
];

export const store_availability_fields = [
	{
		name: "Partner",
		key: "partner",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: [{ name: "", key: "" }],
		},
	},
	{
		name: "Distributor",
		key: "distributor",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: ZONE_OPTIONS,
		},
	},
	{
		name: "Zone",
		key: "zone",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: ZONE_OPTIONS,
		},
	},
	{
		name: "State",
		key: "state",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: [{ name: "", key: "" }],
		},
	},
	{
		name: "City",
		key: "city",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: [{ name: "Loading...", key: "Loading" }],
		},
	},
	{
		name: "Store Grade",
		key: "store_grade",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: [{ name: "Loading...", key: "Loading" }],
		},
	},
	// {
	// 	name: "Distributer",
	// 	key: "distributer",
	// 	input_type: inputTypes.MULTIPLE_SELECT.key,
	// 	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 0,
	// 	group: discountGroupObjects.store_availability.key,
	// 	select_options: {
	// 		type: arrType,
	// 		list: [{ name: "Loading...", key: "Loading" }],
	// 	},
	// },
	{
		name: "Store",
		key: "store",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: discountGroupObjects.store_availability.key,
		select_options: {
			type: arrType,
			list: [{ name: "Loading...", key: "Loading" }],
		},
	},
];
